import { SvgIconProps } from '@traba/types'

export function Moon({
  size,
  color = '#7A8A99',
  strokeWidth = '1.5',
  ...rest
}: SvgIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M8.93241 5.09737C8.9967 4.91816 9.2533 4.91816 9.31759 5.09737L9.4934 5.5874C9.51398 5.64477 9.55967 5.6899 9.61775 5.71022L10.1139 5.88386C10.2954 5.94736 10.2954 6.20079 10.1139 6.26429L9.61775 6.43793C9.55967 6.45825 9.51398 6.50338 9.4934 6.56074L9.31759 7.05078C9.2533 7.22999 8.9967 7.22999 8.93241 7.05078L8.7566 6.56074C8.73602 6.50338 8.69033 6.45825 8.63225 6.43793L8.13608 6.26429C7.95464 6.20079 7.95464 5.94736 8.13608 5.88386L8.63225 5.71022C8.69033 5.6899 8.73602 5.64477 8.7566 5.5874L8.93241 5.09737Z"
        fill={color}
      />
      <path
        d="M10.8716 7.27479C10.9145 7.15532 11.0855 7.15532 11.1284 7.27479L11.2456 7.60148C11.2593 7.63972 11.2898 7.66981 11.3285 7.68336L11.6593 7.79912C11.7802 7.84145 11.7802 8.01041 11.6593 8.05274L11.3285 8.1685C11.2898 8.18205 11.2593 8.21213 11.2456 8.25037L11.1284 8.57706C11.0855 8.69653 10.9145 8.69653 10.8716 8.57706L10.7544 8.25037C10.7407 8.21213 10.7102 8.18205 10.6715 8.1685L10.3407 8.05274C10.2198 8.01041 10.2198 7.84145 10.3407 7.79912L10.6715 7.68336C10.7102 7.66981 10.7407 7.63972 10.7544 7.60148L10.8716 7.27479Z"
        fill={color}
      />
      <path
        d="M11.8462 2.19456C11.9393 1.93515 12.3107 1.93515 12.4038 2.19456L12.7228 3.08367C12.7526 3.16671 12.8187 3.23203 12.9028 3.26146L13.803 3.5765C14.0657 3.66842 14.0657 4.03529 13.803 4.1272L12.9028 4.44225C12.8187 4.47167 12.7526 4.53699 12.7228 4.62003L12.4038 5.50914C12.3107 5.76856 11.9393 5.76856 11.8462 5.50914L11.5272 4.62003C11.4974 4.53699 11.4313 4.47167 11.3472 4.44225L10.447 4.1272C10.1843 4.03529 10.1843 3.66842 10.447 3.5765L11.3472 3.26146C11.4313 3.23203 11.4974 3.16671 11.5272 3.08367L11.8462 2.19456Z"
        fill={color}
      />
      <path
        d="M2 8.9731C2 11.7494 4.31613 14 7.17323 14C9.37272 14 11.2516 12.6662 12 10.7855C11.4073 11.0561 10.7454 11.2073 10.0472 11.2073C7.5076 11.2073 5.44882 9.20673 5.44882 6.73892C5.44882 5.70684 5.80892 4.75647 6.41369 4C3.91668 4.357 2 6.44755 2 8.9731Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
